import _ from 'lodash'

/* Leaflet */
import 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet/dist/images/layers.png'
import 'leaflet/dist/images/layers-2x.png'
import 'leaflet/dist/images/marker-icon.png'
import 'leaflet/dist/images/marker-icon-2x.png'
import 'leaflet/dist/images/marker-shadow.png'

import '../lib/leaflet.groupedlayercontrol.min'
import '../lib/leaflet.groupedlayercontrol.min.css'

import BaseLayers from './BaseLayers'

/* Leaflet Editable */
import 'leaflet-editable/src/Leaflet.Editable'
import '../lib/Path.Drag'

/* Leaflet MarkerCluster */
import 'leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'

/* Измерения */
import 'leaflet-measure/dist/leaflet-measure'
import 'leaflet-measure/dist/leaflet-measure.css'
import 'leaflet-measure/dist/images/cancel.png'
import 'leaflet-measure/dist/images/cancel_@2X.png'
import 'leaflet-measure/dist/images/check.png'
import 'leaflet-measure/dist/images/check_@2X.png'
import 'leaflet-measure/dist/images/focus.png'
import 'leaflet-measure/dist/images/focus_@2X.png'
import 'leaflet-measure/dist/images/rulers.png'
import 'leaflet-measure/dist/images/rulers_@2X.png'
import 'leaflet-measure/dist/images/start.png'
import 'leaflet-measure/dist/images/start_@2X.png'
import 'leaflet-measure/dist/images/trash.png'
import 'leaflet-measure/dist/images/trash_@2X.png'
import '../lib/leaflet-measure-path'
import '../lib/leaflet-measure-path.css'

/* Non-tiled Layer */
import 'leaflet.nontiledlayer'

import './leaflet/focus/leaflet.focus'

import LeafletPointNumbers from './leaflet/pointnumbers/leaflet.pointnumbers'
import './leaflet/pointnumbers/leaftet.pointnumbers.css'

/* Зависимости */
import UniversalKV from './templates/UniversalKV.vue'
import RosreestrShape from './templates/RosreestrShape.vue'
import SputnikShape from './templates/SputnikShape.vue'
import CoordinateList from './templates/CoordinateList.vue'
import TerritoryShapeView from './templates/TerritoryShapeView.vue'
import TemplateShapeView from './templates/TemplateShapeView.vue'

import ShapeViewer from './ShapeViewer.vue'
import WFSTEditor from './WFSTEditor.vue'
import CoordinateUtils from './CoordinateUtils'

import './VueControl'

/* Рассчеты параметров полигона */
import Area from '@turf/area'
import Distance from '@turf/line-distance'

import proj4 from 'proj4'

import MobileDetect from 'mobile-detect'
import Clipboard from 'clipboard'

import Rosreestr from './Rosreestr'
import Sputnik from './Sputnik'
import OOPT from './OOPT'
// import Dashboard from './Dashboard'

const BING_KEY = "Ah4kQH0BQej_eHU-S7KCXy_UxUHExoUjgNy_CTWWA5orSMx1s2RDgHddo88klI9j";

export default {
    template: require('./templates/GeoMap.html'),
    components: {
        UniversalKV,
        RosreestrShape,
        SputnikShape,
        CoordinateList,
        TerritoryShapeView,
        TemplateShapeView,
    },
    props: ['name', 'view', 'edit', 'geoserver', 'projections', 'authkey', 'layer_groups', 'templates'],
    data() {
        return {
            /* Включить кластеризацию */
            onCluster: true,

            /* Включить кластеризацию */
            showMarkers: true,

            /* ID контейнера карты */
            id: 'geo-map-' + Math.floor(Math.random() * 1e10),

            /* Поисковая строка */
            query: '',

            /* Результаты поиска */
            results: [],

            /* Идет загрузка */
            loading: false,

            /* Сообщение об ошибке */
            error: null,

            /* Уведомление */
            notification: null,

            coordinates: [],
            coordinatesVisible: false,

            /* Есть ли куда отправлять результат поиска */
            haveResultReceiver: false,

            /* Стиль подсветки слоя */
            highlightStyle: {
                weight: 2,
                color: '#000',
                fill: false,
                opacity: 0.2
            },

            selectedStyle: {
                weight: 2,
                color: '#000',
                fill: false,
                opacity: 0.8
            },

            shapeStyle: {
                color: 'red',
                weight: 2
            },

            cadastreIcon: new L.Icon.Default({
                iconUrl: 'marker-cadastre-icon.png'
            }),

            markerLayersPolygonStyle: {
                weight: 0,
                opacity: 1,
                fillOpacity: 0.1,
                fillColor: '#FF0037'
            },

            mapstate: JSON.parse(this.$cookie.get('mapstate')) || {
                baselayer: 'Карта OSM',
                overlays: _.map(this.getDefaultLayers(), 'name')
            }
        }
    },

    computed: {
        sortedResults: function () {
            return _.sortBy(this.results, result => this.$options.filters.resultOrder(result.type));
        },

        isGeometryQuery: function () {
            return !!_.get(this.query, 'geometry');
        }
    },

    watch: {
        results() {
            window.bus.$emit('search:results:changed', this.results);
        },
        error() {
            this.$nextTick(this.updateMapSize);
        },
        notification() {
            this.$nextTick(this.updateMapSize);
        },
        loading() {
            this.$nextTick(this.updateMapSize);

            if (this.results.length == 1 && this.loading == false) {
                this.highlight(this.results[0].id);
            }
        }
    },

    methods: {
        getWmsService: function () {
            return this.geoserver + '/wms?authkey=' + this.authkey;
        },

        getGwcService: function () {
            return this.geoserver + '/gwc/service/wms?tiled=true&authkey=' + this.authkey;
        },

        getWfsService: function () {
            return this.geoserver + '/ows?authkey=' + this.authkey;
        },

        updateMapSize: function () {
            this.map.getContainer().setAttribute('style', `height: ${ this.$root.$el.offsetHeight }px`);
            this.map.invalidateSize();

            let scrollerHeight = this.map.getSize().y - 120 - _(this.$el.getElementsByClassName('messages')).map('offsetHeight').sum();
            _.each(this.$el.getElementsByClassName('map-sidebar-scroller'), el => el.setAttribute('style', `max-height: ${ scrollerHeight }px`));

            if (jQuery) {
                let scroller = jQuery('.map-sidebar-scroller');

                if (scroller && scroller.slimScroll) {
                    scroller.slimScroll({size: "5px", height: '', alwaysVisible: true});
                }
            }
        },

        highlightCadastre: function (result) {
            result.status = 'loading';

            let _lastZoom = this.map.getZoom();

            if (result.layer && result.layer.getBounds) {
                this.map.fitBounds(result.layer.getBounds(), {animate: false});
            }

            this.rosreestr.getFeatureData(result.object.id, result.object.type.id).then(feature => _.merge(result.object, feature.attrs));

            var overlay = this.rosreestr.getOverlayImage(result.object.id, this.map, result.object.type).on('load', ev => {
                var geo = ev.target.exportGeometry();
                this.map.setZoom(_lastZoom);

                if (geo) {
                    if (_(this.markerLayers.getLayers()).some(item => item == result.layer)) {
                        this.markerLayers.removeLayer(result.layer);
                        result.status = 'loaded';
                        result.layer = geo;
                        geo.setStyle(result.selected ? this.selectedStyle : this.highlightStyle);
                        geo.addTo(this.markerLayers);
                    }
                } else {
                    result.status = result.layer ? 'onlybbox' : 'nogeo';
                }
            }).on('tileerror', () => result.status = 'failed');

            overlay.addTo(this.markerLayers);
        },

        saveMapState: function () {
            this.$cookie.set('mapstate', JSON.stringify(this.mapstate), '1Y');
        },

        traverseLayers: function* (collection) {
            if (collection && collection.getLayers) {
                for (let layer of collection.getLayers()) {
                    yield* this.traverseLayers(layer);
                }
            }
            else {
                yield collection;
            }
        },

        getDefaultLayers: function() {
            return _.flatMap(this.layer_groups, group => _.chain(group)
                .pickBy('showByDefault')
                .map((layer, id) => _.merge({}, {id: id, name: layer.name}))
                .value());
        },

        getForcedLayers: function() {
            return _.flatMap(this.layer_groups, group => _.chain(group)
                .pickBy('showAlways')
                .map((layer, id) => _.merge({}, {id: id, name: layer.name}))
                .value());
        },

        _getKeys: function () {
            let param = _.get(this, ['view', 'options', 'param'], 'NatureClusterId');
            return [param];
        },

        _getId: function (layer) {
            let feature = layer.feature || layer;
            return feature.id.split('.')[0] + '.' + _(feature.properties).pick(this._getKeys()).values().head();
        },

        _getMaxZoom() {
            const MAX_ZOOM = 17;
            let mapZoom = this.map.getZoom();

            return mapZoom > MAX_ZOOM ? mapZoom : MAX_ZOOM;
        },

        _isWMSLayer(layer) {
            return (layer instanceof L.TileLayer.WMS) || (layer instanceof L.NonTiledLayer.WMS);
        },

        _hasTemplate(type) {
            return _.includes(_.keys(this.$options.components), type);
        },

        _template(type) {
            return _.find(this.templates, {name:type});
        },

        _hasGeometry(layer) {
            if (!layer.toGeoJSON) {
                return false;
            }

            let geoJson = layer.toGeoJSON();
            return !!(geoJson.geometry || geoJson.features.length > 0);
        },

        getCenter: function (layer) {
            if (layer instanceof L.Marker) {
                return layer.getLatLng();
            }

            if (layer.getBounds) {
                return layer.getBounds().getCenter();
            }
        },

        search: function (query) {
            this.markerLayers.clearLayers();
            this.clearResults();
            this.setError();

            this.query = query;

            if (_.isEmpty(query)) {
                window.bus.$emit('map:search:cleared');

                // Восстановить исходный набор маркеров при пустом поисковом запросе
                if (this.view.options && this.view.options.layer) {
                    return this.updateMarkers(this.view.options, true);
                }

                return Promise.resolve();
            }

            let _startLoading = () => {
                this.loading = true;
                this.setError();
            };

            let _completeOk = () => this.loading = false;

            let _completeError = (err) => {
                this.loading = false;

                if (_.isString(err)) {
                    this.setError(err);
                }
                else {
                    let address = _.chain(err.url).split('//').get(1).split('/').get(0).value() || _.truncate(err.url) || 'серверу';
                    let error = `Ошибка при обращении к ${address}. `;

                    if (address.toLowerCase().indexOf("rosreestr") >= 0) {
                        error += "Сервисы Росреестра могут быть загружены в настоящее время, попробуйте выполнить запрос позже"
                    }
                    else {
                        error += "Возможно, отсутсвует подключение к серверу или сервер перегружен и не может обработать запрос";
                    }

                    this.setError(error);
                }

                window.bus.$emit('map:search:error', {
                    error: this.error,
                    query: query
                });
            };

            this.markerLayers.clearLayers();

            _startLoading();

            if (this.isGeometryQuery) {
                let layer = query.geometry;

                if (this.map.hasLayer(layer)) {
                    let promises = Array.from(this.traverseLayers(layer), this.oopt.intersectsSearchValid);
                    return Promise.all(promises).then(_.flatten).then(this.populateResultsFromTerritorySearch).then(_completeOk).catch(_completeError);
                }

                return Promise.resolve();
            }

            if (_.trim(query).split(/[\s;]+/).length > 1) {
                let testCoordinates = CoordinateUtils.parseCoordinates(query);

                if (testCoordinates) {
                    return this.pinpoint(this.reproject(testCoordinates)).then(_completeOk).catch(_completeError);
                }
            }

            let oopt = this.oopt.intersectsSearchAll(query).then(this.populateResultsFromTerritorySearch);
            let cadastre = this.rosreestr.getFeatures(Rosreestr.FeatureTypes.LandPlots, query).then(this.populateResultsFromRosreestr).then(this.placeRosreestrMarkers);
            //let sputnik = this.sputnik.getFeatures(query).then(this.populateResultsFromSputnik);

            return Promise.all([oopt, cadastre/*, sputnik*/]).then(_completeOk).catch(_completeError);
        },

        rehighlightMarkers: function (filter) {
            if (this.query || this.results.length > 0) {
                // Если задан поисковый запрос, очистить его и загрузить список маркеров списка
                this.search().then(() => this.highlightMarkers(filter, true));
            } else {
                // Если поисковый запрос не задан, сразу подсветить маркер
                this.highlightMarkers(filter, true);
            }
        },

        inclusions: function (query) {
            if (_.isEmpty(query)) {
                return;
            }

            let oopt = this.oopt;
            let crs = L.Projection.SphericalMercator;

            // Извлечение центра кадастрового участка
            let _getCenter = feature => {
                return crs.unproject(L.point(feature.center.x, feature.center.y));
            };

            // Извлечение ограничивающего прямоугольника кадастрового участка
            let _getBbox = feature => {
                if (feature.extent) {
                    return L.latLngBounds(
                        crs.unproject(L.point(feature.extent.xmin, feature.extent.ymin)),
                        crs.unproject(L.point(feature.extent.xmax, feature.extent.ymax))
                    );
                }
            };

            // Формирование сообщения из свойств результата поиска
            let _getProperties = feature => {
                feature = feature.feature || feature;

                return {
                    type: feature.id.split('.')[0],
                    query: query,
                    properties: feature.properties
                };
            };

            // Отправка резульататов поиска в шину событий
            let _emitResults = features => {
                let results = _(features).uniqBy(this._getId).map(_getProperties).value();

                if (_.isEmpty(results)) {
                    results = {empty: true, query: query};
                }

                window.bus.$emit('map:search:results', results);
            };

            let _emitError = () => {
                let error = {
                    error: 'Не удалось получить ответ от сервера',
                    query: query
                };
                window.bus.$emit('map:search:results', error);
                window.bus.$emit('map:search:error', error);
            };

            // Поиск вхождений заданной геометрии в слои ООПТ
            if (_.get(query, 'geometry')) {
                let layer = L.geoJSON(query.geometry);
                return Promise.all(Array.from(this.traverseLayers(layer), oopt.intersectsSearchValid)).then(_.flatten).then(_emitResults).catch(_emitError);
            }

            // Поиск по одиночным координатам
            if (_.trim(query).split(/[\s;]+/).length > 1) {
                let testCoordinates = CoordinateUtils.parseCoordinates(query);

                if (testCoordinates) {
                    let latlng = this.reproject(testCoordinates);
                    return oopt.intersectsSearchValid(latlng).then(_emitResults).catch(_emitError);
                }
            }

            // Если в запросе не координаты, ищем по кадастру Росреестра
            this.rosreestr
                .getFeatures(Rosreestr.FeatureTypes.LandPlots, query)
                .then(features => {
                    let borders = _(features).map(_getBbox).remove().value();

                    if (_.isEmpty(borders)) {
                        window.bus.$emit('map:search:results', {cnNotFound: true, query: query});
                    }
                    else {
                        return Promise.all(_.map(borders, oopt.intersectsSearchValid)).then(_.flatten).then(_emitResults);
                    }
                })
                .catch(_emitError);
        },

        highlight: function (id) {
            this.results.forEach(item => {
                item.selected = (item.id == id) ? !item.selected : false;

                if (item.layer) {
                    if (item.layer instanceof L.Marker) {
                        if (item.selected) {
                            this.map.panTo(item.layer.getLatLng());
                        }
                    } else {
                        item.layer.setStyle(item.selected ? this.selectedStyle : this.highlightStyle);

                        if (item.selected) {
                            this.map.fitBounds(item.layer.getBounds(), {animate: false, maxZoom: this._getMaxZoom()});

                            if (item.onhighlight) {
                                item.onhighlight(item);
                            }
                        }
                    }
                }

                if (item.selected) {
                    window.bus.$emit('map:markers:highlight', [_.set({}, item.markerHighlightParam, item.objectId)]);
                }
            });

            if (_.every(this.results, ['selected', false])) {
                // Убрать выделение маркеров
                window.bus.$emit('map:markers:highlight', []);

                // Убрать выделение слоев
                _(this.results).map('layer').remove().filter(o => !(o instanceof L.Marker)).forEach(layer => layer.setStyle(this.highlightStyle));
            }
        },

        scrollToSelected() {
            this.$nextTick(() => {
                let selected = document.getElementsByClassName('map-result-selected')[0];
                let scroller = document.getElementsByClassName('map-sidebar-scroller')[0];

                if (selected) {
                    scroller.scrollTop = selected.offsetTop;
                }
            });
        },

        getMeasurements: function (layer) {
            let geoJson = layer.toGeoJSON();

            try {
                return {
                    area: Area(geoJson),
                    distance: Distance(geoJson) * 1000
                };
            } catch (e) {
                return {
                    area: null,
                    area: null
                }
            }
        },

        populateResultsFromLayers: function (layers, keys) {
            _.each(layers, layer => {
                let {area, distance} = this.getMeasurements(layer);

                let result = _.omitBy({
                    id: layer.feature.id,
                    type: layer.feature.id.split('.')[0],
                    objectId: _(layer.feature.properties).pick(keys).values().head(),
                    markerHighlightParam: _(layer.feature.properties).pick(keys).keys().head(),
                    object: layer.feature.properties,
                    selected: false,
                    area: area,
                    distance: distance,
                    layer: this._hasGeometry(layer) ? layer : null
                }, _.isNil);

                this.results.push(result);
            });
        },

        getVisibleLayers: function () {
            let layers = [];

            this.map.eachLayer(layer => {
                if (this._isWMSLayer(layer) && layer.options.searchable) {
                    layers.push(layer);
                }
            });

            return layers;
        },

        redrawVisibleLayers: function () {
            _.each(this.getVisibleLayers(), layer => {
                layer.wmsParams.rand = Math.random();
                layer.redraw();
            });
        },

        placeRosreestrMarkers: function (features) {
            _(this.results).filter({
                type: 'RosreestrShape'
            }).each(result => {
                if (result.layer) {
                    let center = this.getCenter(result.layer);
                    let marker = L.marker(center).setIcon(this.cadastreIcon).addTo(this.markerLayers);
                    marker.on('click', () => {
                        this.highlight(result.id);
                        this.scrollToSelected()
                    });

                    if (_.get(this.view, 'options.sendResults')) {
                        _.each(this.getVisibleLayers(), layer => this.oopt.coordinateSearch(center, layer.options).then(this.populateResultsFromWms));
                    }
                }
            });
        },

        populateResultsFromRosreestr: function (features) {
            _(features).each(feature => {
                let crs = L.Projection.SphericalMercator;
                let layer = null;

                if (feature.extent) {
                    let bounds = L.latLngBounds(
                        crs.unproject(L.point(feature.extent.xmin, feature.extent.ymin)),
                        crs.unproject(L.point(feature.extent.xmax, feature.extent.ymax))
                    );

                    layer = L.rectangle(bounds).setStyle(this.highlightStyle).addTo(this.markerLayers);
                }

                feature.attrs.type = _.find(Rosreestr.FeatureTypes, ['id', feature.type]);
                feature.attrs.Name = feature.attrs.type.id === Rosreestr.FeatureTypes.SpecialAreas.id ? feature.attrs.id : feature.attrs.cn;

                let result = {
                    id: feature.attrs.id,
                    type: 'RosreestrShape',
                    objectId: feature.attrs.id,
                    object: feature.attrs,
                    selected: false,
                    layer: layer,
                    status: layer ? '' : 'nogeo',
                    onhighlight: item => {
                        if (!_.includes(['loading', 'loaded'], item.status)) {
                            this.highlightCadastre(item);
                        }
                    }
                };

                this.results.push(result);
            });
        },

        populateResultsFromSputnik: function (features) {
            let cadastreIcon = new L.Icon.Default({
                iconUrl: 'marker-cadastre-icon.png'
            });

            _.each(features, feature => {
                let maker = L.marker([feature.position.lat, feature.position.lon]).setIcon(cadastreIcon).addTo(this.markerLayers);
                feature.Name = feature.title + ' (' + feature.description + ')';

                let result = {
                    id: feature.id,
                    type: 'SputnikShape',
                    objectId: feature.id,
                    object: feature,
                    selected: false,
                    layer: maker
                };

                maker.on('click', () => {
                    this.highlight(result.id);
                    this.scrollToSelected()
                });
                this.results.push(result);
            });
        },

        populateResultsFromTerritorySearch: function (features, markersOnly) {
            let layers = features;
            // let layers = L.geoJSON(_.uniqBy(features, 'id')).getLayers();

            if (!markersOnly) {
                let clustered = _(layers).groupBy(this._getId).map((cluster, id) => {
                    let group = L.featureGroup();
                    _.each(cluster, layer => group.addLayer(layer));
                    _.merge(group, {feature: {id: id, properties: cluster[0].feature.properties}});
                    return group;
                }).value()

                this.populateResultsFromLayers(clustered, this._getKeys());
            }

            this.addSearchMarkers(layers);
        },

        populateResultsFromWms: function (features) {
            if (features && features.length) {
                let layers = L.geoJson(features, {
                    style: this.highlightStyle
                }).addTo(this.markerLayers).getLayers();
                this.populateResultsFromLayers(layers, this._getKeys());
            }
        },

        sendResult: function (event, result) {
            window.bus.$emit('map:search:result', {
                type: result.type,
                id: result.objectId,
                query: this.query,
                properties: _.clone(result.object)
            });
            event.stopPropagation();
        },

        clearResults: function () {
            _.filter(this.results, {
                selected: true
            }).forEach(result => this.highlight(result.id));

            this.results = [];
        },

        highlightMarkers: function (filter, zoom) {
            let markers = [];
            let defaultIcon = new L.Icon.Default();
            let highlightIcon = new L.Icon.Default({
                iconUrl: 'marker-highlight-icon.png'
            });

            this.selectRaws(filter);

            this.markerLayers.eachLayer(marker => {
                if (marker.feature && marker.feature.properties) {
                    let icon = defaultIcon;

                    if (_.filter(filter, predicate => _.filter([marker.feature.properties], predicate).length > 0).length > 0) {
                        markers.push(marker);
                        icon = highlightIcon;
                    }

                    if (marker instanceof L.Marker) {
                        marker.setIcon(icon);
                    }
                }
            });

            if (zoom && markers.length) {
                this.map.fitBounds(L.featureGroup(markers).getBounds(), {animate: false, maxZoom: this._getMaxZoom()});
            }
        },

        selectRaws(filter) {

            if (!_.isEmpty(filter)) {
                let scroller = $('#slim-filter .slimScrollDiv #grid-list-container');
                jQuery('.card-side #slim-filter tr[data-key]').css('backgroundColor', 'transparent');

                _.forEach(filter, id => {
                    _.forEach(this._getKeys(), key => {
                        let selected = jQuery('.card-side #slim-filter tr[data-key=' + _.get(id, key, -1) + ']');

                        if (selected.length) {
                            selected.css('backgroundColor', '#f2fbff');
                            scroller.slimScroll({scrollTo: selected.prop('offsetTop')});
                        }
                    });
                });
            }
        },

        addSearchMarkers(layers) {

            _.each(layers, layer => {
                if (!this._hasGeometry(layer)) {
                    return;
                }

                let id = this._getId(layer);
                let param = _(layer.feature.properties).pick(this._getKeys()).keys().head();
                let result = _.find(this.results, ['id', id]);

                if (!(layer instanceof L.Marker)) {
                    layer.setStyle(this.highlightStyle);
                    layer.addTo(this.markerLayers);
                }

                let marker = L.marker(this.getCenter(layer));

                if (result) {
                    result.highlightMarker = marker;
                    result.markerHighlightParam = param;
                }

                _.merge(marker, {
                    feature: {
                        id: id,
                        properties: layer.feature.properties
                    }
                });

                marker.on('click', () => {
                    if (_.isEmpty(this.results) || (_.isEmpty(this.query) && this.results[0].id != id)) {
                        this.clearResults();
                        this.populateResultsFromLayers([marker], [param]);
                    }
                    else {
                        this.highlight(id);
                        this.scrollToSelected();
                    }
                });

                if (this.showMarkers) {
                    marker.addTo(this.markerLayers);
                }
            });

            if (layers.length > 0) {
                this.fitLayer = this.markerLayers;
            }
        },

        updateMarkers: function (options, keepBounds, keepExisting) {
            if (!keepExisting) {
                this.markerLayers.clearLayers();
                this.clearResults();
            }

            return this.oopt.intersectsSearchLayer(options, options.layer).then(layers => {
                this.populateResultsFromTerritorySearch(layers, true);

                if (!keepBounds) {
                    this.focus();
                }
            });
        },

        toggleCoordinates: function () {
            this.coordinatesVisible = !this.coordinatesVisible;
        },

        updateCoordinates: function () {
            let _isNotWgs = p => !_.isFinite(Number(p.lat)) ||
                !_.isFinite(Number(p.lng)) ||
                p.lat > 180 || p.lat < -180 ||
                p.lng > 180 || p.lng < -180;

            if (_.flattenDeep(this.coordinates).some(_isNotWgs)) {
                this.setError("Введенные координаты не принадлежат зоне WGS-84");
                return;
            }

            window.bus.$emit('map:system:updatecoordinates', this.coordinates);
        },

        setError: function (message) {
            this.error = message;
        },

        setNotification: function (message) {
            this.notification = message;
        },

        convertCoordinates: function () {
            this.setError();
            _.flattenDeep(this.coordinates).map(this.reproject);
        },

        focus: function () {
            if (!this.fitLayer) {
                return;
            }

            if (this.map.getSize().y == 0) {
                this._focusOnLoad = true;
                return;
            }

            this.$nextTick(() => {
                if (this.fitLayer.getBounds) {
                    let bounds = this.fitLayer.getBounds();

                    if (L.latLngBounds(bounds).isValid()) {
                        this.map.fitBounds(bounds, {animate: false, maxZoom: this._getMaxZoom()});
                    }
                }

                if (this.fitLayer.getLatLng) {
                    this.map.panTo(this.fitLayer.getLatLng());
                }
            });
        },

        panView(position) {
            if (position.zoom) this.map.setZoom(position.zoom, {animate: false});
            if (position.center) this.map.panTo(position.center, {animate: false});
        },

        copy: function () {
            let _getLevels = () => {
                if (_.isArray(this.coordinates[0]) && _.isArray(this.coordinates[0][0])) {
                    return ['Мультиполигон', 'Полигон', 'Граница'];
                }

                if (_.isArray(this.coordinates[0])) {
                    return ['Полигон', 'Граница'];
                }

                if (this.coordinates.length > 1) {
                    return ['Граница'];
                }

                return ['Точка'];
            };

            let levels = _getLevels();

            let latLngToString = (latLng, idx, level) => {
                let title = level > 0 ? levels[level] + ` ${idx + 1}\n` : '';

                if (_.isArray(latLng)) {
                    return title + _.map(latLng, (el, idx) => latLngToString(el, idx, level + 1)).join('\n') + '\n';
                }

                return latLng.lat + '\t' + latLng.lng;
            }

            return latLngToString(this.coordinates, 0, 0).trim();
        },

        reproject: function (latLng) {
            let x = Math.abs(latLng.lat);
            let y = Math.abs(latLng.lng);

            if (_.isFinite(x) && _.isFinite(y)) {
                let zone = x.toString()[0];
                let srcProjection = '';

                if (x > 180) {
                    // МСК
                    for (let projection in this.projections) {
                        let m = this.projections[projection].match(/\+x_0=(\d)/);

                        if (m && m[1] == zone) {
                            srcProjection = projection;
                            break;
                        }
                    }

                    if (!_.isEmpty(srcProjection)) {
                        let unprojected = proj4(srcProjection, 'EPSG:4326', _.map([latLng.lat, latLng.lng], Number));
                        latLng.lat = unprojected[1];
                        latLng.lng = unprojected[0];
                    }
                    else {
                        this.setError("Введенные координаты не принадлежат МСК");
                    }
                }
            }
            else {
                this.setError("Введенные координаты не содержат пары чисел");
            }

            return latLng;
        },

        canSendResult: function (type) {
            return this.haveResultReceiver && _.chain(this.view).get('options.sendResults').indexOf(type).value() >= 0;
        },

        mapMoved() {
            return this._mapMoveStart;
        },

        swapCoordinates: function () {
            _.flattenDeep(this.coordinates).forEach(latlng => [latlng.lat, latlng.lng] = [latlng.lng, latlng.lat]);
        },

        pinpoint: function (latlng) {
            let cadastreTypes = [];

            L.marker(latlng).addTo(this.markerLayers);
            this.map.panTo(latlng);

            this.map.eachLayer(layer => {
                if (this._isWMSLayer(layer) && layer.options.cadastreLayer) {
                    cadastreTypes.push(layer.options.cadastreType);
                }
            });

            let wmsSearch = Promise.all(_.map(this.getVisibleLayers(), layer => this.oopt.coordinateSearch(latlng, layer.options))).then(_.flatten).then(this.populateResultsFromWms);
            let promises = [wmsSearch];

            if (cadastreTypes.length > 0) {
                _.uniqBy(cadastreTypes, 'id').forEach(type => promises.push(this.rosreestr.getFeatures(type, latlng).then(this.populateResultsFromRosreestr)));
            }

            return Promise.all(promises);
        }
    },

    mounted() {
        let id = this.id;
        let bounds = [
            [42, 43.6],
            [48, 35.2]
        ];

        // TODO: Перенести в настройки
        let center = [58.306602995027966, 43.6541748046875];
        let initialZoom = 8;
        let maxZoom = 22;

        let editable = !!this.edit || (_.get(this.view, 'options.shapeViewer'));
        let map = L.map(id, {editable: editable, maxZoom: maxZoom});

        map.on('resize', () => {
            if (this._focusOnLoad) {
                this._focusOnLoad = false;
                this.focus();
            }
        });

        map.setView(center, initialZoom);

        this.map = map;

        for (let projection in this.projections) {
            proj4.defs(projection, this.projections[projection]);
        }

        this.rosreestr = new Rosreestr(this);
        this.sputnik = new Sputnik(this);
        this.oopt = new OOPT(this);
        // this.dashboard = new Dashboard(this);

        _.bindAll(this.oopt, ['intersectsSearchValid', 'intersectsSearchAll', 'intersectsSearchLayer']);

        let _wmsOptions = {
            maxZoom: 22,
            transparent: true,
            format: 'image/png',
            version: '1.1.0',
            // tiled: true,
            // crs: L.CRS.EPSG4326,
            reuseTiles: false,
        };

        // if (_.get(this, 'view.options.dashboard')) {
        //     this.dashboard.show();
        // }

        if (_.get(this, 'view.options.showPointNumbers') || _.get(this, 'edit.options.showPointNumbers')) {
            LeafletPointNumbers.enablePointNumbers();
        }

        let sputnik = BaseLayers.sputnik();
        let esriTopo = BaseLayers.esriTopo();
        let esriImagery = BaseLayers.esriImagery();
        let hillshade = BaseLayers.hillshade();
        let labels = BaseLayers.labels();
        let rosreestr = BaseLayers.rosreestr();
        let rosreestrSpesialZones = BaseLayers.rosreestrSpesialZones();
        let rosreestrQuarter = BaseLayers.rosreestrQuarter();

        // Создание отдельного pane для слоя rosreestrQuarter
        this.map.createPane('rosreestrQuarterPane')
        this.map.getPane('rosreestrQuarterPane').style.zIndex = 200;

        let basemaps = {
            "Карта OSM": sputnik,
            "Топография ESRI": esriTopo,
            "Космические снимки ESRI": esriImagery,
            "Космические снимки Bing": BaseLayers.bing(BING_KEY),
            "Космические снимки Google": BaseLayers.google()
        };

        let overlays = {
            "Тематические карты": {
            },

            "Общедоступные кадастровые сведения": {
                "Кадастровые кварталы": rosreestrQuarter,
                "Земельные участки": rosreestr,
                "Зоны с особыми условиями <br> использования территории": rosreestrSpesialZones,
            },

            "Дополнительные сведения": {
                "Надписи": labels,
                "Отмывка рельефа ESRI": hillshade,
            },
        };

        for (let groupName in this.layer_groups) {
            let groupLayers = this.layer_groups[groupName];

            if (overlays[groupName] === undefined) {
                overlays[groupName] = {};
            }

            for (let geoserverLayerName in groupLayers) {
                let layer = groupLayers[geoserverLayerName];
                overlays[groupName][layer.name] = L.nonTiledLayer.wms(this.getWmsService(), _.merge({}, _wmsOptions, {
                    'layers': geoserverLayerName,
                    zIndex: layer.zindex,
                    searchable: layer.searchable,
                    FORMAT_OPTIONS: layer.legend ? 'layout:legend' : ''
                }));
            }
        }

        let overlaysOptions = {
            autoZIndex: false,
            groupsCollapsable: true,
            groupsExpandedClass: "glyphicon glyphicon-chevron-down",
            groupsCollapsedClass: "glyphicon glyphicon-chevron-right"
        };

        L.control.groupedLayers(basemaps, overlays, overlaysOptions).addTo(map);

        let _getType = layer => {
            let tokens = layer.split(':');
            return _.get(tokens, 1, tokens[0]);
        }

        _.chain(this.layer_groups)
            .map(group => _.map(group, (v, k) => {
                return {
                    name: _getType(k),
                    title: v.name,
                    order: 1000 - v.zindex
                };
            }))
            .flatMap()
            .value()
            .forEach(t => this.$root.$options.searchResultTypes.push(t));

        // Сохранение набора слоев карты при изменении выбора слоев
        map.on('baselayerchange', e => {
            this.mapstate.baselayer = e.name;
            this.saveMapState();
        });
        map.on('overlayadd', e => {
            this.mapstate.overlays = _(this.mapstate.overlays).push(e.name).uniq().value();
            this.saveMapState();
        });
        map.on('overlayremove', e => {
            this.mapstate.overlays = _.pull(this.mapstate.overlays, e.name);
            this.saveMapState();
        });

        // Загрузка состояния выбранных слоев карты
        _.get(basemaps, this.mapstate.baselayer, basemaps[_.keys(basemaps)[0]]).addTo(map);

        let forceAddLayers = _.map(this.getForcedLayers(), 'id');

        if (_.get(this, 'view.options.layer')) {
            forceAddLayers.push(this.view.options.layer);
        }

        for (let group in overlays) {
            for (let name in overlays[group]) {
                let layer = overlays[group][name];

                if ((_.indexOf(this.mapstate.overlays, name) >= 0) ||
                    (_.indexOf(forceAddLayers, _.get(layer, 'options.layers')) >= 0) ||
                    (layer.cadastreLayer && this.view.options && this.view.options.sendResults)) {
                    layer.addTo(map);
                }
            }
        }

        // Если предполагается отправка результатов поиска по участкам, всегда добавлять слой Росреестра
        if (this.view.options && this.view.options.sendResults) {
            rosreestr.addTo(map);
        }

        // Слой результатов поиска
        // Кластеризация
        if (this.onCluster) {
            this.markerLayers = L.markerClusterGroup({
                showCoverageOnHover: false,
                maxClusterRadius: (zoom) => (zoom <= 14) && !this.query ? 40 : 0, // radius in pixels
            });

            this.markerLayers.setStyle({
                fill: false
            });
        } else {
            this.markerLayers = L.featureGroup({
                showCoverageOnHover: false,
            });
        }


        map.addLayer(this.markerLayers);

        let measureControl = new L.Control.Measure({
            position: 'topright',
            primaryLengthUnit: 'meters',
            secondaryLengthUnit: 'kilometers',
            primaryAreaUnit: 'sqmeters',
            secondaryAreaUnit: undefined,
            localization: 'ru',
            activeColor: '#e62c2e',
            completedColor: '#f2bb00'
        });

        measureControl.addTo(map);

        L.mapFocus({
            header: this.name,
            position: 'bottomright'
        }).addTo(map);

        map.zoomControl.setPosition('bottomright');
        map.attributionControl.setPosition('bottomleft');

        if (this.view) {
            map.on("click", e => map.disableOnClick ? false : this.search(e.latlng.lat + ' ' + e.latlng.lng));

            if (this.view.options && this.view.options.layer) {
                this.updateMarkers(this.view.options);
            }


            if (this.view.options && this.view.options.shapeViewer) {
                L.vueControl(ShapeViewer, {
                    vm: this,
                    position: 'bottomright',
                    shapeStyle: this.shapeStyle
                }).addTo(map);
            }
        }

        if (this.edit) {
            L.vueControl(WFSTEditor, {
                vm: this,
                position: 'bottomright',
                shapeStyle: this.shapeStyle,
                options: this.edit.options,
                service: this.getWfsService()
            }).addTo(map);
        }

        map.on("mousedown", () => this._mapMoveStart = false);
        map.on("movestart", () => this._mapMoveStart = true);

        let md = new MobileDetect(window.navigator.userAgent);
        if (!md.mobile()) {
            map.touchZoom.disable();
            map.doubleClickZoom.disable();

            if (map.tap) {
                map.tap.disable();
            }
        }

        window.bus.$on('map:search:query', this.search);
        window.bus.$on('map:search:inclusions', this.inclusions);
        window.bus.$on('map:search:setreceiver', v => this.haveResultReceiver = v);
        window.bus.$on('map:markers:update', this.updateMarkers);
        window.bus.$on('map:focus', this.focus);
        window.bus.$on('map:markers:highlight', this.highlightMarkers);
        window.bus.$on('map:markers:rehighlight', this.rehighlightMarkers);
        window.bus.$on('map:system:redraw', this.redrawVisibleLayers);
        window.bus.$on('map:system:error', this.setError);
        window.bus.$on('map:system:notification', this.setNotification);
        window.bus.$on('map:view:pan', this.panView);

        // Подгонка карты по размеру окна
        let _onresize = _.debounce(this.updateMapSize, 150);

        if (jQuery) {
            jQuery(window).resize(_onresize);
        }
        else {
            window.addEventListener("resize", _onresize);
        }

        this.$nextTick(this.updateMapSize);

        new Clipboard('.map-edit-copy', {
            text: this.copy
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/GeoMap.js